// src/icons/CreditCardIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function CreditCardIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 25,
    viewBox: "0 0 25 25",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M22.3685 5.3375V18.5542C22.3685 18.9608 22.216 19.3167 21.911 19.6217C21.606 19.9267 21.2502 20.0792 20.8435 20.0792H3.56016C3.15349 20.0792 2.79766 19.9267 2.49266 19.6217C2.18766 19.3167 2.03516 18.9608 2.03516 18.5542V5.3375C2.03516 4.93083 2.18766 4.575 2.49266 4.27C2.79766 3.965 3.15349 3.8125 3.56016 3.8125H20.8435C21.2502 3.8125 21.606 3.965 21.911 4.27C22.216 4.575 22.3685 4.93083 22.3685 5.3375ZM3.56016 8.10792H20.8435V5.3375H3.56016V8.10792ZM3.56016 11.3867V18.5542H20.8435V11.3867H3.56016Z",
        fill: "currentColor"
      })
    ]
  });
}
export {
  CreditCardIcon
};
//# sourceMappingURL=CreditCardIcon.mjs.map